"use client";

import { ScrollReveal } from "../shared";
import WalletSearchBar from "../../app/components/WalletSearchBar";

/**
 * Homepage search bar. Matches the client reference exactly: a single
 * rounded-2xl bar with a gradient "Search" button, no heading and no filter
 * pills above/below it. Wraps the real WalletSearchBar - unchanged
 * search/resolve logic, same /api/search and /api/resolve-wallet endpoints -
 * via its additive `variant="panel"` prop, which only changes the visual
 * shape and submit-button label. Every other usage of WalletSearchBar
 * (header, etc.) is untouched.
 */
export default function LargeSearchSection() {
  return (
    <section aria-label="Universal search" className="page-section relative z-10 w-full py-4 sm:py-6">
      <ScrollReveal>
        <div className="mx-auto max-w-6xl">
          <div className="section-panel rounded-[28px] border p-4 sm:p-6">
            <div className="mb-4 flex flex-wrap items-end justify-between gap-4">
              <div>
                <p className="eyebrow-label">Universal Search</p>
                <p className="prose-muted mt-2 max-w-2xl text-sm sm:text-base">
                  Search wallets, transaction hashes, ENS names, and domains from one operator-grade entry point.
                </p>
              </div>
              {/* Supported-input chips. Search boxes convert far better when
                  the visitor can see what they're allowed to paste before
                  they type - this removes the "will it understand this?"
                  hesitation without adding a help link. */}
              <div className="flex flex-wrap items-center gap-4">
                {["0x address", "tx hash", "ENS", "domain"].map((chip) => (
                  <span
                    key={chip}
                    className="rounded-full bg-white/[0.07] px-3 py-1.5 text-[11px] font-semibold tracking-wide text-slate-200 shadow-sm transition-colors hover:bg-white/[0.1]"
                  >
                    {chip}
                  </span>
                ))}
              </div>
            </div>
            <WalletSearchBar
              size="lg"
              variant="panel"
              submitLabel="Search"
              placeholder="Search wallet or tx hash (address, ENS, domain)"
              className="w-full"
            />
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
}
